import { render, staticRenderFns } from "./GenerateHeadings.vue?vue&type=template&id=dec1d534"
import script from "./GenerateHeadings.vue?vue&type=script&lang=js"
export * from "./GenerateHeadings.vue?vue&type=script&lang=js"
import style0 from "./GenerateHeadings.vue?vue&type=style&index=0&id=dec1d534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports